export const categoryCheckboxConfig = {
  id: 'category-checkbox',
  label: '',
  disabled: false,
  value: {},
  callback: 'categoryCheckboxClicked',
  isChecked: true,
};
